const Spacer: React.FC = () => {
  return <div className="h-10 lg:h-[80px]"></div>;
};

export default Spacer;
